import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdService, ServedAd } from '@app/services/ad.service';

@Component({
  selector: 'app-sponsored-listing',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (ad) {
      <div class="sponsored-listing" (click)="onClick()">
        <div class="sponsored-icon">
          @if (ad.imageUrl) {
            <img [src]="ad.imageUrl" [alt]="ad.headline">
          } @else {
            {{ (ad.headline || 'Ad')[0] }}
          }
        </div>
        <div class="sponsored-text">
          <div class="sponsored-top">
            <span class="sponsored-headline">{{ ad.headline }}</span>
            <span class="sponsored-badge">Sponsored</span>
          </div>
          <span class="sponsored-desc">{{ ad.description || ad.displayUrl }}</span>
        </div>
      </div>
    }
  `,
  styles: [`
    .sponsored-listing {
      padding: 12px 16px;
      cursor: pointer;
      border-bottom: 1px solid #e5e7eb;
      background: #f0f7ff;
      display: flex;
      gap: 10px;
      align-items: center;
      transition: background 0.15s;
    }
    .sponsored-listing:hover { background: #e0efff; }

    .sponsored-icon {
      width: 36px; height: 36px; border-radius: 6px;
      background: #1565C0; color: white; flex-shrink: 0;
      display: flex; align-items: center; justify-content: center;
      font-size: 14px; font-weight: 600; overflow: hidden;
    }
    .sponsored-icon img { width: 100%; height: 100%; object-fit: cover; }

    .sponsored-text { flex: 1; min-width: 0; }
    .sponsored-top { display: flex; align-items: center; gap: 6px; }
    .sponsored-headline { font-size: 13px; font-weight: 500; color: #1a1a1a; }
    .sponsored-badge {
      font-size: 9px; color: #1565C0; background: #dbeafe;
      padding: 1px 6px; border-radius: 8px; font-weight: 500; flex-shrink: 0;
    }
    .sponsored-desc { display: block; font-size: 11px; color: #6b7280; margin-top: 2px; }
  `]
})
export class SponsoredListingComponent implements OnInit {
  private adService = inject(AdService);
  ad: ServedAd | null = null;

  ngOnInit() {
    this.adService.getAd('SEARCH_RESULTS').subscribe(ad => this.ad = ad);
  }

  onClick() {
    if (this.ad) this.adService.recordClick(this.ad);
  }
}
